import IconHelper from "./IconHelper";

const DigitalTurbineTextLogoIcon = (props) => {
  return (
    <IconHelper {...props} defaultWidth={109} defaultHeight={37}>
      <svg
        width="76"
        height="36"
        viewBox="0 0 76 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.4303 8.11325C15.4325 9.53012 11.7193 14.0032 11.4384 19.3851C9.70049 17.3329 8.65235 14.6779 8.65234 11.778C8.65234 5.27322 13.9255 2.84332e-07 20.4303 0V8.11325Z"
          fill="#FFA500"
        />
        <path
          d="M15.3861 27.704C20.384 26.2871 24.0971 21.814 24.378 16.4321C26.1159 18.4844 27.1641 21.1394 27.1641 24.0393C27.1641 30.544 21.8909 35.8172 15.3861 35.8172V27.704Z"
          fill="#CC0E93"
        />
        <path
          d="M27.7051 20.4302C26.2882 15.4323 21.8151 11.7192 16.4333 11.4383C18.4855 9.70037 21.1405 8.65223 24.0404 8.65222C30.5451 8.65222 35.8184 13.9254 35.8184 20.4302L27.7051 20.4302Z"
          fill="#F04C0A"
        />
        <path
          d="M8.11325 15.3873C9.53012 20.3852 14.0032 24.0983 19.3851 24.3792C17.3329 26.1172 14.6779 27.1653 11.778 27.1653C5.27322 27.1653 5.14831e-07 21.8921 5.14832e-07 15.3873L8.11325 15.3873Z"
          fill="#8336D6"
        />
        <path
          d="M69.5123 13.3203V26.84H63.6767V13.3203H57.709V8.67285H75.4536V13.3203H69.5123Z"
          fill="#414141"
        />
        <path
          d="M49.0662 8.67287C55.4212 8.67287 58.5986 11.7007 58.5986 17.7564C58.5986 23.8122 55.4212 26.84 49.0662 26.84H41.1973V8.67287H49.0662ZM47.0329 22.4831H48.9605C51.4075 22.4831 52.6309 21.1716 52.6309 18.5486V16.9643C52.6309 14.3413 51.4075 13.0298 48.9605 13.0298H47.0329V22.4831Z"
          fill="#414141"
        />
      </svg>
    </IconHelper>
  );
};

export default DigitalTurbineTextLogoIcon;
